'use client';

import { Suspense } from 'react';
import { Bounds, useBounds } from '@react-three/drei';
import { ViewerCanvas } from './viewer-canvas';
import { GlbModel } from './glb-model';

function ModelFitInner({ url }: { url: string }) {
  const api = useBounds();
  return (
    <GlbModel
      url={url}
      onLoaded={() => {
        requestAnimationFrame(() => {
          api.refresh().clip().reset();
        });
      }}
    />
  );
}

/** Large modal preview: orbit + environment, camera frames the loaded mesh bounds. */
export function AssetModalModelPreview({ url, className }: { url: string; className?: string }) {
  return (
    <div className={className} style={{ width: '100%', height: '100%', minHeight: 400 }}>
      <ViewerCanvas
        className="h-full w-full min-h-[400px]"
        environmentPreset="studio"
        backgroundColor="#18181b"
        cameraPosition={[2.2, 1.6, 2.2]}
        cameraTarget={[0, 0, 0]}
        cameraFov={42}
        autoRotate
        autoRotateSpeed={0.6}
      >
        <Suspense fallback={null}>
          <Bounds margin={1.35}>
            <ModelFitInner url={url} />
          </Bounds>
        </Suspense>
      </ViewerCanvas>
    </div>
  );
}
